<template>
  <div>
    <v-layout px-0 py-2 wrap>
      <v-flex md6 xs12 mb-2>
        <v-card
          :to="{ name: 'callDetail', params: { id: activeCallId } }"
          class="detailPanel"
          color="yellow darken-2"
          tile
        >
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>business</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.details') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md6 xs12 mb-2>
        <v-card
          :to="{ name: 'location' }"
          class="locationPanel"
          color="indigo darken-2"
          tile
        >
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>map</v-icon>
            <div class="headline text-xs-center">Location</div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex
        md6
        xs12
        mb-2
        v-if="
          callDetail.status === 'Arrival Completed' ||
            callDetail.status === 'Departed'
        "
      >
        <v-card
          class="powraPanel"
          @click.native="confirmEditPowra()"
          color="green darken-4"
          tile
        >
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>warning</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.powra') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex md6 xs12 mb-2 v-if="callDetail.status === 'Travelling'">
        <v-card
          :color="
            callDetail.status === 'Travelling'
              ? 'blue darken-2'
              : 'grey darken-2'
          "
          @click.native="checkProximity()"
          class="travellingPanel"
          tile
        >
          <v-card-text class="white--text text-xs-center">
            <v-progress-circular
              :size="72"
              color="white"
              indeterminate
              v-if="this.arrivalProgress"
              width="6"
            ></v-progress-circular>
            <div v-else>
              <v-icon color="white" x-large>highlight_off</v-icon>
              <div class="headline text-xs-center">
                {{ $vuetify.t('$vuetify.calls.arrived') }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md6 xs12 mb-2 v-if="callDetail.status === 'Arrived'">
        <v-card
          :class="callDetail.status === 'Arrived' ? 'blue darken-2' : ''"
          @click="arrivalProcessBegin()"
          color="blue darken-2"
          tile
        >
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>highlight_off</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.arrivalComplete') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex
        md6
        xs12
        mb-2
        v-if="
          callDetail.status === 'Arrival Completed' ||
            callDetail.status === 'Departed'
        "
      >
        <v-card
          :class="
            callDetail.status === 'Arrival Completed' ? 'completePanel' : ''
          "
          :to="{ path: '/form/engineer-worksheet' }"
          color="cyan darken-2"
          tile
        >
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>book</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.worksheet') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex
        md6
        xs12
        mb-2
        v-if="
          callDetail.status === 'Arrival Completed' ||
            callDetail.status === 'Departed'
        "
      >
        <v-card
          :class="
            callDetail.status === 'Arrival Completed' ? 'completePanel' : ''
          "
          :to="{ name: 'callComplete', params: { id: activeCallId } }"
          color="green darken-2"
          tile
        >
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>highlight_off</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.complete') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex
        md6
        xs12
        mb-2
        v-if="
          callDetail.status === 'Arrival Completed' ||
            callDetail.status === 'Departed'
        "
      >
        <v-card :to="{ name: 'media' }" color="purple darken-2" tile>
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>camera</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.media') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex
        md6
        xs12
        mb-2
        v-if="
          callDetail.status === 'Arrival Completed' ||
            callDetail.status === 'Departed'
        "
      >
        <v-card :to="{ name: 'scans' }" color="red darken-2" tile>
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>description</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.documents') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md6 x12 mb-2>
        <v-card to="/forms" color="orange darken-1" tile>
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>dvr</v-icon>
            <div class="headline text-xs-center">
              Other Forms
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md12 xs12>
        <v-card
          v-if="callDetail.status !== 'Departed'"
          @click.native="dialog = true"
          class="resetPanel"
          color="black darken-2"
          tile
        >
          <v-card-text class="white--text text-xs-center">
            <v-icon color="white" x-large>highlight_off</v-icon>
            <div class="headline text-xs-center">
              {{ $vuetify.t('$vuetify.calls.reset') }}
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $vuetify.t('$vuetify.calls.resetCallHeader') }}
        </v-card-title>

        <v-card-text>
          {{ $vuetify.t('$vuetify.calls.resetCallBody') }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" color="primary" flat>
            {{ $vuetify.t('$vuetify.app.cancel') }}
          </v-btn>
          <v-btn @click="confirmReset" color="primary" flat>
            {{ $vuetify.t('$vuetify.calls.resetCallConfirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <proximity-dialog
      :distance-to-site="this.distanceToSite"
      ref="proximityDialog"
      v-on:accept-proximity-warning="confirmProximity"
    ></proximity-dialog>

    <edit-powra-dialog
      ref="editPowraDialog"
      v-on:accept-edit-powra-warning="setPowraMode"
    ></edit-powra-dialog>

    <contract-notes
      :notes="callDetail.contract_note"
      :show="contractNotesDialog"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back="contractNotesDialog = false"
      v-on:confirmed="contractNotesConfirmed(callDetail.id)"
    />

    <sign-in-method
      :method="callDetail.sign_in_method"
      :link="callDetail.sign_in_link"
      :show="signInMethodDialog"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back="
        callDetail.contract_note ? (contractNotesDialog = true) : '',
          (signInMethodDialog = false)
      "
      v-on:confirmed="signInMethodConfirmed(callDetail.id)"
    />

    <work-assessment
      :show="workAssessmentDialog"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back=";(signInMethodDialog = true), (workAssessmentDialog = false)"
      v-on:confirmed="workAssessmentConfirmed(callDetail.id, ...arguments)"
      v-on:close="workAssessmentDialog = false"
    />

    <pre-work-analysis
      :duration="callDetail.estimated_duration_minutes"
      :show="preWorkAnalysisDialog"
      v-on:aborted="visitAborted(callDetail.id)"
      v-on:back="
        ;(workAssessmentDialog = true), (preWorkAnalysisDialog = false)
      "
      v-on:confirmed="preWorkAnalysisConfirmed(callDetail.id, ...arguments)"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import callActions from '../mixins/callActions.js'
import formatting from '../mixins/formatting.js'
import proximityDialog from '@/components/ProximityDialog.vue'
import editPowraDialog from '@/components/EditPowraDialog.vue'
import ContractNotes from '@/components/arrival/ContractNotes.vue'
import SignInMethod from '@/components/arrival/SignInMethod.vue'
import WorkAssessment from '@/components/arrival/WorkAssessment.vue'
import PreWorkAnalysis from '@/components/arrival/PreWorkAnalysis.vue'
import moment from 'moment'

export default {
  name: 'ActiveCall',
  mixins: [callActions, formatting],
  components: {
    'proximity-dialog': proximityDialog,
    'edit-powra-dialog': editPowraDialog,
    ContractNotes,
    SignInMethod,
    WorkAssessment,
    PreWorkAnalysis
  },
  data() {
    return {
      dialog: false,
      proximityDialog: false,
      editPowraDialog: false,
      arrivalProgress: false,
      contractNotesDialog: false,
      signInMethodDialog: false,
      workAssessmentDialog: false,
      preWorkAnalysisDialog: false,
      onSiteArrivalProcess: {
        contract_notes_acknowledged_at: null,
        sign_in_confirmed_at: null,
        site_occupied: 0,
        powra_completed: 0,
        asbestos_register_signed: 0,
        asbestos_checkin_completed: 0,
        asbestos_present: 0,
        lone_working_policy: 0,
        work_assessment_escalation_at: null,
        approved_by_name: null,
        approved_by_position: null,
        approved_by_signature_path: null,
        estimated_time_minutes: null,
        estimated_cost_gbp: null,
        approved_by_signature: null
      },
      fetchingCurrentPowra: false,
      currentPowraFetched: false
    }
  },
  watch: {
    callDetail: function(newVal, oldVal) {
      if (_.isEmpty(newVal)) this.$router.push({ name: 'callsList' })

      if (!this.fetchingCurrentPowra && !this.currentPowraFetched) {
        if (
          newVal.status === 'Arrival Completed' ||
          newVal.status === 'Departed'
        ) {
          this.fetchingCurrentPowra = true

          this.fetchCurrentRiskAssessment({
            call_assignment_id: newVal.id
          })

          this.fetchingCurrentPowra = false
          this.currentPowraFetched = true
        }
      }
    }
  },
  computed: {
    ...mapState({
      calls: state => state.calls.list,
      distanceToSite: state =>
        state.location.distanceToSite ? state.location.distanceToSite.value : 0,
      hasPowra: state => state.calls.hasPowra,
      hasWorksheet: state => state.calls.hasWorksheet,
      isTestUser: state => state.root.testUser
    }),
    ...mapGetters({
      activeCallId: 'calls/activeCallId',
      callDetail: 'calls/getActiveCall',
      hasActiveCall: 'calls/hasActiveCall',
      user: 'root/user'
    })
  },
  mounted() {},
  methods: {
    ...mapActions({
      arrived: 'calls/arrived',
      reset: 'calls/reset',
      onsiteArrivalProcess: 'calls/onsiteArrivalProcess',
      fetchCurrentRiskAssessment: 'calls/fetchCurrentRiskAssessment',
      fetchLocation: 'location/fetch',
      setHasPowra: 'calls/setHasPowra',
      getETA: 'location/eta'
    }),
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),
    checkProximity(callback = this.arrivalOnsiteProcess) {
      this.fetchLocation()
        .then(pos => {
          pos.routeParams = null
          const origin = new window.google.maps.LatLng(
            pos.coords.latitude,
            pos.coords.longitude
          )

          const destination = new window.google.maps.LatLng(
            this.callDetail.latitude,
            this.callDetail.longitude
          )
          if (this.hasActiveCall()) {
            pos.routeParams = {
              callId: this.activeCallId,
              origin: origin,
              destination: destination
            }
          }
          return pos
        })

        // Record the position
        .then(pos => {
          if (pos.routeParams) {
            this.getETA(pos.routeParams)
              .then(r => {
                if (r.status === 'OK') {
                  pos.coords.distance_to_site = r.distance.value
                  pos.coords.eta = r.duration.value
                  if (r.distance.value > process.env.VUE_APP_PROXIMITY) {
                    this.$refs.proximityDialog.show()
                  } else {
                    callback()
                  }
                }
                this.recordLocation(pos.coords)
                return pos
              })
              .catch(e => {
                this.recordLocation(pos.coords)
                console.error(e)
              })
          }
        })
        .catch(e => {
          console.log('Location Error', e)
          if (e.code == 1) {
            this.setNotification({
              message:
                'You must enable location to use this app, if you denied location service you will need to remove the app from the blacklist. Click the Help link below or contact your controller who will walk you through the process.',
              color: 'error',
              timeout: 20000,
              showHelp: true
            })
          }
          console.error('********************************', e)
        })
    },
    confirmProximity(callback = this.arrivalOnsiteProcess) {
      this.$refs.proximityDialog.hide()
      callback()
    },
    arrivalOnsiteProcess(callId = this.callDetail.id) {
      this._mSaveArrivalTime(callId)
      this._mArriveCall(callId).then(() => {
        this.arrivalProcessBegin()
      })
    },
    confirmEditPowra() {
      this.$refs.editPowraDialog.show()
    },
    arrivalProcessBegin() {
      this.setHasPowra(false)
      if (this.callDetail.contract_note) {
        this.contractNotesDialog = true
      } else {
        this.signInMethodDialog = true
      }
    },
    setPowraMode() {
      this.$refs.editPowraDialog.hide()
      this.setHasPowra(true)
      if (this.callDetail.contract_note) {
        this.workAssessmentDialog = true
      } else {
        this.workAssessmentDialog = true
      }
      this.fetchCurrentRiskAssessment({
        call_assignment_id: this.callDetail.id
      })
    },
    contractNotesConfirmed(callId) {
      this.contractNotesDialog = false
      this.onSiteArrivalProcess.contract_notes_acknowledged_at = moment().format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.signInMethodDialog = true
    },
    signInMethodConfirmed(callId) {
      this.signInMethodDialog = false
      this.onSiteArrivalProcess.callId = callId
      this.onSiteArrivalProcess.sign_in_confirmed_at = moment().format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.workAssessmentDialog = true
    },
    workAssessmentConfirmed(callId, payload) {
      this.workAssessmentDialog = false
      this.onSiteArrivalProcess.site_occupied = payload.site_occupied
      this.onSiteArrivalProcess.powra_completed = payload.powra_completed
      this.onSiteArrivalProcess.asbestos_register_signed =
        payload.asbestos_register_signed
      this.onSiteArrivalProcess.asbestos_checkin_completed = payload.asbestos_checkin_completed
        ? payload.asbestos_checkin_completed
        : 0
      this.onSiteArrivalProcess.asbestos_present = payload.asbestos_present
        ? payload.asbestos_present
        : 0
      this.onSiteArrivalProcess.lone_working_policy =
        payload.lone_working_policy
      this.onSiteArrivalProcess.work_assessment_escalation_at =
        payload.work_assessment_escalation_at
      this.preWorkAnalysisDialog = true
    },
    async preWorkAnalysisConfirmed(callId, payload) {
      this.preWorkAnalysisDialog = false
      this.onSiteArrivalProcess.estimated_time_minutes =
        payload.estimated_time_minutes
      this.onSiteArrivalProcess.estimated_cost_gbp = payload.estimated_cost_gbp
      await this.onsiteArrivalProcess(this.onSiteArrivalProcess)
        .then(() => {
          this.arrivalCompletedCall(callId)
        })
        .catch(() => {
          this.setNotification(this.$vuetify.t('$vuetify.calls.callNotArrived'))
        })
    },
    visitAborted(callId) {
      this.arrivalCompletedCall(callId)
      this.$router.push({ name: 'callComplete', params: { id: callId } })
    },
    arrivalCompletedCall(callId) {
      this.arrivalProgress = true
      this._mArrivalCompleted(callId)
        .then(response => {
          this.arrivalProgress = true
        })
        .catch(() => {
          this.setNotification(this.$vuetify.t('$vuetify.calls.callNotArrived'))
        })
    },
    confirmReset() {
      this.dialog = false
      this.reset(this.callDetail.id)
        .then(() => {
          this.setNotification(this.$vuetify.t('$vuetify.calls.callReset'))
        })
        .catch(() => {
          this.setNotification(this.$vuetify.t('$vuetify.calls.callNotReseted'))
        })
    }
  }
}
</script>

<style scoped lang="scss">
.travellingPanel {
  cursor: pointer;
}
.powraPanel {
  cursor: pointer;
}
.completePanel {
  cursor: pointer;
}
.resetPanel {
  cursor: pointer;
}
</style>
